import DatePicker, { DatePickerProps } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import 'react-datepicker/dist/react-datepicker-cssmodules.css'
import clsx from 'clsx'

const dateIcon = (
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g opacity="0.3">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.32143 2.57143C6.32143 1.97969 5.84173 1.5 5.25 1.5C4.65827 1.5 4.17857 1.97969 4.17857 2.57143V3.64286H3.10714C2.21954 3.64286 1.5 4.3624 1.5 5.25V6.85714H16.5V5.25C16.5 4.3624 15.7804 3.64286 14.8929 3.64286H13.8215V2.57143C13.8215 1.97969 13.3419 1.5 12.7501 1.5C12.1584 1.5 11.6787 1.97969 11.6787 2.57143V3.64286H6.32143V2.57143ZM16.5 8.19643H1.5V14.8929C1.5 15.7804 2.21954 16.5 3.10714 16.5H14.8929C15.7804 16.5 16.5 15.7804 16.5 14.8929V8.19643Z"
                fill="#0D1317"
            />
        </g>
    </svg>
)

const timeIcon = (
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g opacity="0.3">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85787 13.1421 1.5 9 1.5C4.85787 1.5 1.5 4.85787 1.5 9C1.5 13.1421 4.85787 16.5 9 16.5ZM9.66964 6.32143C9.66964 5.95159 9.36984 5.65179 9 5.65179C8.63016 5.65179 8.33036 5.95159 8.33036 6.32143V9C8.33036 9.15665 8.38528 9.30835 8.48556 9.4287L11.1641 12.643C11.4009 12.9271 11.8231 12.9655 12.1073 12.7287C12.3914 12.492 12.4297 12.0697 12.193 11.7856L9.66964 8.75756V6.32143Z"
                fill="#0D1317"
            />
        </g>
    </svg>
)

export const datepickerIcons = {
    dateIcon,
    timeIcon,
}

type Props = DatePickerProps & {
    error?: string
}

export function AppDatePicker({ error, ...props }: Props) {
    return (
        <div
            className={clsx('form-group input--lg w-full', {
                'input--icon-left': true,
            })}
        >
            <div className="w-full relative">
                {true && (
                    <div className="ico">
                        {props.showTimeSelectOnly ? timeIcon : dateIcon}
                    </div>
                )}
                <DatePicker
                    {...props}
                    showIcon={false}
                />
            </div>
            {error && (
                <label className="form-label">
                    <div
                        className="label--text"
                        style={{ color: 'var(--danger)' }}
                    >
                        <span>{error}</span>
                    </div>
                </label>
            )}
        </div>
    )
}

export default AppDatePicker
